import { UserType } from '../../../types/UserType';
import { getCustomers, getSuppliers } from '../../common/api/clients/company.api';
import { getCustomerGroup } from '../../common/api/clients/customerGroups.api';
import { getSupplierGroup } from '../../common/api/clients/supplierGroups.api';
import { getUser } from '../../common/api/clients/user.api';
import { JWTHelper } from '../../common/JwtHelper';
import { initialize } from '../../common/launchDarkly/launchDarklyClient';
import { AblyService } from '../../common/services/AblyService';

import { RoleService } from './RoleService';

let instance = null;

export class SessionService {
    static getInstance() {
        if (!instance) {
            instance = new SessionService();
        }
        return instance;
    }

    async loadRoleInformation(accessToken) {
        const user = await getUser();
        const isCustomer = user.userType === UserType.CUSTOMER;

        let group = null;
        let companies = null;

        if (user.groupId) {
            if (isCustomer) {
                group = await getCustomerGroup(user.groupId);
                companies = await getCustomers();
            } else {
                group = await getSupplierGroup(user.groupId);
                companies = await getSuppliers();
            }
        }

        const role = RoleService.getInstance().create(JWTHelper.decode(accessToken), user, group, companies);

        try {
            await initialize(role);
            AblyService.connect();
        } catch {
            // Fail silently in case LaunchDarkly has issues.
        }

        RoleService.getInstance().authenticated();

        return role;
    }
}
